import React from 'react';
const SVG = ({
    style = {},
    fill = '#999',
    viewBox = '0 0 75.424 14',
    width = '75.424',
    className = '',
    height = '14',
    ...rest
  }) => (
    <svg 
        xmlns='http://www.w3.org/2000/svg'
        width={width} 
        height={height} viewBox={viewBox} 
        fill={fill}>
        <path d="M25.392 17.754l-5.149 2.816 5.149 2.922 5.18-2.922z" transform="translate(-20.243 -17.754)"/>
        <path d="M29.721 36.934l-4.328 2.453-4.333-2.453-.817.453v2.083l5.149 2.917 5.18-2.917v-2.084z"  transform="translate(-20.243 -28.387)"/>
        <path d="M29.737 27.666l-4.345 2.458-4.331-2.458-.819.453 5.149 2.922 5.18-2.922z"  transform="translate(-20.243 -23.249)"/>
        <path d="M29.737 32.294l-4.345 2.458-4.331-2.458-.819.453 5.149 2.922 5.18-2.922z"  transform="translate(-20.243 -25.815)"/>
    </svg>
);
export default SVG;